import { IUser, IUserRole, Permission, RoleScope, PermissionScope } from 'types/dto';

export class Permissions {
  public constructor(private readonly user: IUser | null) {}

  public has(permission: Permission, scope: PermissionScope | null = null): boolean {
    return (this.user &&
      this.user.roles.some(
        role =>
          this.roleHasPermission(role, scope?.skip ? permission : Permission.GeneralAll) ||
          this.roleHasGlobalPermission(role, permission) ||
          this.roleHasCountryPermission(role, permission, scope) ||
          this.roleHasUserPermission(role, permission, scope),
      )) as boolean;
  }

  public hasOneOf(permissions: Permission[], scope: PermissionScope | null = null): boolean {
    return permissions && permissions.some(permission => this.has(permission, scope));
  }

  public hasAllOf(permissions: Permission[], scope: PermissionScope | null = null): boolean {
    return permissions && permissions.every(permission => this.has(permission, scope));
  }

  private roleHasPermission(role: IUserRole, permission: Permission): boolean {
    return role.role?.permissions.some(p => p.id === permission);
  }

  private roleHasGlobalPermission(role: IUserRole, permission: Permission): boolean {
    return role.role?.scope === RoleScope.Global && role.role?.permissions.some(p => p.id === permission);
  }

  private roleHasCountryPermission(role: IUserRole, permission: Permission, scope: PermissionScope | null): boolean {
    return (
      role.role?.scope === RoleScope.Country &&
      role.country?.globalId === scope?.countryGlobalId &&
      role.role?.permissions.some(p => p.id === permission)
    );
  }

  private roleHasUserPermission(role: IUserRole, permission: Permission, scope: PermissionScope | null): boolean {
    return (
      role.role?.scope === RoleScope.User &&
      (!role.country?.globalId || role.country.globalId === scope?.countryGlobalId) &&
      (!scope?.entityCreatedByAzureId || this.user?.azureId === scope?.entityCreatedByAzureId) &&
      role.role?.permissions.some(p => p.id === permission)
    );
  }
}
